import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("CATEGORIAS_CONTENIDO", newActions, newReducers);

const categoriasContenidoThunk = (page = null, limit = null, estado = null) => {
  let url = page && limit ? `${baseUrl}/getCategoriasContenido?page=${page}&limit=${limit}&estado=${estado}` : `${baseUrl}/getCategoriasContenido?estado=${estado}`;
  return createThunk(axios, "get", duck.actions, url, null);
};


const duckAddCategoriaContenido = createDuck("CATEGORIAS_CONTENIDO_ADD", newActions, newReducers);

const addCategoriaContenidoThunk = (data) => {
  let url = `${baseUrl}/categoria`;
  return createThunk(axios, "post", duckAddCategoriaContenido.actions, url, data);
};

export default {
  duck,
  categoriasContenidoThunk,
  duckAddCategoriaContenido,
  addCategoriaContenidoThunk

};
